import {
  UPDATE_DOCUMENT_REQUEST,
  UPDATE_DOCUMENT_SUCCESS,
  UPDATE_DOCUMENT_FAILURE,
} from '../actions/update_document_data'

export const updateDocumentData = (
  state = {
    isFetching: false,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_DOCUMENT_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case UPDATE_DOCUMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      }
    case UPDATE_DOCUMENT_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
